import { Injectable } from '@angular/core';
import { HttpServices } from './http-service.service';
import { GlobalServices } from './global.service';
import { Languages } from '../models/enums.model';
import { Params } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MyTasksService {

  constructor(private http: HttpServices, private global: GlobalServices) { }

  public getPendingTasks (userName: string, pageIndex: number, pageSize: number, primSortBy: string, primSortDirection: string,
                          secSortBy: string, secSortDirection: string, IsAdmin: boolean ) {
    return this.http.get('Tasks/GetPendingTasks?userName=' + userName + '&pageIndex=' + pageIndex + '&pageSize=' + pageSize
                         + '&primSortBy=' + primSortBy + '&primSortDirection=' + primSortDirection
                         + '&secSortBy=' + secSortBy + '&secSortDirection=' + secSortDirection
                         + '&lang=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En")
                         + '&isAdmin=' + IsAdmin);
  }
  public getAdminTasksByRequestId (userName: string, requestId: string) {
  return this.http.get('Tasks/GetAdminTasksByRequestId?userName=' + userName + '&requestId=' + requestId +
  '&lang=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En"));
}

  public GetSmallUnitsPendingTasks (userName: string, pageIndex: number, pageSize: number, primSortBy: string, primSortDirection: string,
                          secSortBy: string, secSortDirection: string) {
    return this.http.get('Tasks/GetSmallUnitsPendingTasks?userName=' + userName + '&pageIndex=' + pageIndex + '&pageSize=' + pageSize
                         + '&primSortBy=' + primSortBy + '&primSortDirection=' + primSortDirection
                         + '&secSortBy=' + secSortBy + '&secSortDirection=' + secSortDirection
                         + '&lang=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En"));
  }
  public GetLongHaulPendingTasks (userName: string, pageIndex: number, pageSize: number, primSortBy: string, primSortDirection: string,
    secSortBy: string, secSortDirection: string) {
return this.http.get('Tasks/GetLongHaulPendingTasks?userName=' + userName + '&pageIndex=' + pageIndex + '&pageSize=' + pageSize
   + '&primSortBy=' + primSortBy + '&primSortDirection=' + primSortDirection
   + '&secSortBy=' + secSortBy + '&secSortDirection=' + secSortDirection
   + '&lang=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En"));
}

  public GetPendingTasksByServicesandCircular (CircularId,services: Array<number>, userName: string, pageIndex: number, pageSize: number, primSortBy: string, primSortDirection: string,
    secSortBy: string, secSortDirection: string) {
return this.http.get('Tasks/GetPendingTasksByCircularID?CircularId='+ CircularId +'&Services=' + services
   + '&userName=' + userName + '&pageIndex=' + pageIndex + '&pageSize=' + pageSize
   + '&primSortBy=' + primSortBy + '&primSortDirection=' + primSortDirection
   + '&secSortBy=' + secSortBy + '&secSortDirection=' + secSortDirection
   + '&lang=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En"));
}
  public GetPendingTasksByServices (services: Array<number>, userName: string, pageIndex: number, pageSize: number, primSortBy: string, primSortDirection: string,
    secSortBy: string, secSortDirection: string) {
return this.http.get('Tasks/GetPendingTasksByService?Services=' + services
   + '&userName=' + userName + '&pageIndex=' + pageIndex + '&pageSize=' + pageSize
   + '&primSortBy=' + primSortBy + '&primSortDirection=' + primSortDirection
   + '&secSortBy=' + secSortBy + '&secSortDirection=' + secSortDirection
   + '&lang=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En"));
}
}
